import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type DescriptionFillProps = IconComponentBaseProps;

export const DescriptionFill = ({
  className,
  width = 20,
  height = 20,
  fill = defaultTheme.mantineColors.gray[8],
}: DescriptionFillProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_10823_77659"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10823_77659)">
        <path
          d="M7.5 14.7916H12.5C12.6771 14.7916 12.8255 14.7317 12.9452 14.6119C13.0651 14.492 13.125 14.3435 13.125 14.1664C13.125 13.9892 13.0651 13.8408 12.9452 13.7212C12.8255 13.6015 12.6771 13.5416 12.5 13.5416H7.5C7.32292 13.5416 7.17451 13.6016 7.05479 13.7214C6.93493 13.8413 6.875 13.9898 6.875 14.1669C6.875 14.3441 6.93493 14.4925 7.05479 14.6121C7.17451 14.7318 7.32292 14.7916 7.5 14.7916ZM7.5 11.4583H12.5C12.6771 11.4583 12.8255 11.3984 12.9452 11.2785C13.0651 11.1587 13.125 11.0102 13.125 10.8331C13.125 10.6559 13.0651 10.5075 12.9452 10.3879C12.8255 10.2682 12.6771 10.2083 12.5 10.2083H7.5C7.32292 10.2083 7.17451 10.2682 7.05479 10.3881C6.93493 10.508 6.875 10.6564 6.875 10.8335C6.875 11.0107 6.93493 11.1591 7.05479 11.2787C7.17451 11.3985 7.32292 11.4583 7.5 11.4583ZM5.25646 17.9166C4.83549 17.9166 4.47917 17.7708 4.1875 17.4791C3.89583 17.1875 3.75 16.8312 3.75 16.4102V3.58977C3.75 3.1688 3.89583 2.81248 4.1875 2.52081C4.47917 2.22915 4.83549 2.08331 5.25646 2.08331H11.2517C11.4549 2.08331 11.6485 2.12234 11.8327 2.2004C12.0169 2.27831 12.1774 2.38567 12.3142 2.52248L15.8108 6.01915C15.9476 6.15595 16.055 6.31644 16.1329 6.50061C16.211 6.68477 16.25 6.87845 16.25 7.08165V16.4102C16.25 16.8312 16.1042 17.1875 15.8125 17.4791C15.5208 17.7708 15.1645 17.9166 14.7435 17.9166H5.25646ZM11.25 6.33331C11.25 6.54581 11.3219 6.72394 11.4656 6.86769C11.6094 7.01144 11.7875 7.08331 12 7.08331H15L11.25 3.33331V6.33331Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
